export default function ({ app, params }, shortPath) {
  const paramKeys = Object.keys(params).filter((e) => e != "lang")
  const modPath = paramKeys.length
    ? (function () {
        let cpy = shortPath.toString()
        for (let key in params) {
          cpy = cpy.replace(params[key], `:${key}`)
        }
        return cpy
      })()
    : shortPath
  const searchTerm = modPath.endsWith("/")
    ? modPath.substr(0, modPath.length - 2)
    : modPath

  return app.router.options.routes.some((e) =>
    `${e.path}/`.includes(searchTerm)
  )
}
